import { BaseCustomerOfferTabsEnum } from '../_enums/base-customer-offer-tabs.enum';

export const BaseCustomerOfferInitialAdminTabList = [
  {
    id: BaseCustomerOfferTabsEnum.MaterData,
    title: 'masterData',
  },
  {
    id: BaseCustomerOfferTabsEnum.AssignmentInformation,
    title: 'externalEmployees.operationInfo.title',
  },
  {
    id: BaseCustomerOfferTabsEnum.WorkCouncil,
    title: 'workCouncil.label',
  },
  {
    id: BaseCustomerOfferTabsEnum.Documents,
    title: 'document.plural',
  },
  {
    id: BaseCustomerOfferTabsEnum.TimeRecordings,
    title: 'externalEmployees.timeRecordings.title',
  },
];

export const BaseCustomerOfferInitialTabList = [
  {
    id: BaseCustomerOfferTabsEnum.MaterData,
    title: 'masterData',
  },
  {
    id: BaseCustomerOfferTabsEnum.OfferInformation,
    title: 'inquiry.offerInformation',
  },
  {
    id: BaseCustomerOfferTabsEnum.WorkCouncil,
    title: 'workCouncil.label',
  },
  {
    id: BaseCustomerOfferTabsEnum.Documents,
    title: 'document.plural',
  },
];
